export default __webpack_public_path__ + "static/media/Shot_28.0000.a53b9bf8.png";